// Pieces of the printable entry (printEntry): HTML escaping, the logo
// header and the print window. The submissions report is a PDF the worker
// builds (pitpay-go), with the same header.

export const escapeHtml = (value) =>
  String(value == null ? '' : value).replace(
    /[&<>"']/g,
    (c) =>
      ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[c])
  );

export const BRAND_CSS = [
  '.lh{display:flex;align-items:center;gap:14px;margin-bottom:18px}',
  '.lg{flex:none;width:46px;height:46px;border-radius:11px;object-fit:contain;-webkit-print-color-adjust:exact;print-color-adjust:exact}',
  '.lg.mono{display:flex;align-items:center;justify-content:center;background:#0F0F23;color:#fff;font-weight:800;font-size:16px;letter-spacing:.5px}',
  '.lg.mono.s{font-size:12px}',
  '.lh-t{flex:1;min-width:0}',
  '.lh-n{font-size:15px;font-weight:800;letter-spacing:-.2px;color:#1F2A30}',
  '.lh-s{font-size:11px;color:#64748B;margin-top:1px}',
  '.lh-p{flex:none;display:flex;align-items:center;gap:10px;font-size:10px;color:#64748B;text-align:right;line-height:1.35}',
  '.lh-p b{display:block;font-size:11.5px;color:#1F2A30}',
].join('');

// brand = brandInfo(account); sub = the line under the account name.
export const brandHeaderHtml = (b, sub) => {
  const mark = b.logo
    ? `<img class="lg" src="${escapeHtml(b.logo)}" alt="">`
    : `<div class="lg mono${b.mono.length > 2 ? ' s' : ''}">${escapeHtml(
        b.mono
      )}</div>`;
  return (
    `<div class="lh">${mark}` +
    `<div class="lh-t"><div class="lh-n">${escapeHtml(
      b.name || 'Unassigned account'
    )}</div><div class="lh-s">${escapeHtml(sub || '')}</div></div>` +
    `<div class="lh-p"><span>Powered by<b>${escapeHtml(
      b.platform
    )}</b></span>` +
    `<img class="lg" src="${escapeHtml(b.platformLogo)}" alt="${escapeHtml(
      b.platform
    )}"></div></div>`
  );
};

// Prints once the logos have loaded (or after a short wait).
export const PRINT_SCRIPT =
  '<script>window.onload=function(){setTimeout(function(){window.print();},350);};</script>';

// Opens the HTML in a new tab, which prints itself. → 'opened' | 'blocked'
export const openPrintWindow = (html) => {
  const win = window.open('', '_blank');
  if (!win) return 'blocked';
  win.document.open();
  win.document.write(html);
  win.document.close();
  return 'opened';
};
